import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 费用tab-运价表查询
export function queryEffectiveSurchargeFCL(data) {
  return request({
    url: URL.price.queryEffectiveSurchargeFCL,
    method: 'post',
    data
  })
}
// 整箱运价详情-运价表查询2
export function queryEffectiveSurchargeFCL2(data) {
  return request({
    url: URL.price.queryEffectiveSurchargeFCL2,
    method: 'post',
    data
  })
}
// 整箱运价详情-运价表查询3
export function queryEffectiveSurchargeFCL3(data) {
  return request({
    url: URL.price.queryEffectiveSurchargeFCL3,
    method: 'post',
    data
  })
}
// 整箱运价详情-已审核列表查询
export function queryEffectiveSurchargeFCL4(data) {
  return request({
    url: URL.price.queryEffectiveSurchargeFCL4,
    method: 'post',
    data
  })
}
// 整箱运价详情-待审核列表查询
export function queryPendingSurchargeFCL2(data) {
  return request({
    url: URL.price.queryPendingSurchargeFCL2,
    method: 'post',
    data
  })
}
// 整箱运价详情-保存信息（新增或修改）
export function saveSurchargeFCL(data) {
  return request({
    url: URL.price.saveSurchargeFCL,
    method: 'post',
    data
  })
}
// 整箱运价详情-待审核列表查询
export function deleteSurchargeFCL(data) {
  return request({
    url: URL.price.deleteSurchargeFCL,
    method: 'post',
    data
  })
}
// 整箱运价详情-审核
export function approveSurchargeFCLs(data) {
  return request({
    url: URL.price.approveSurchargeFCLs,
    method: 'post',
    data
  })
}
// 整箱附加费-excel校验
export function checkSurchargeExcel(file) {
  const data = new FormData()
  data.append('file', file)
  return request({
    url: URL.price.checkSurchargeExcel,
    method: 'post',
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    data
  })
}
// 运价表-配置附加费信息查询
export function querySurchargeFclConfig() {
  return request({
    url: URL.price.querySurchargeFclConfig,
    method: 'get'
  })
}
// 运价表-配置的附加费列表信息查询
export function querySurchargeFclByConfig(params) {
  return request({
    url: URL.price.querySurchargeFclByConfig,
    method: 'get',
    params
  })
}
// 运价表-保存配置附加费信息
export function saveSurchargeFCLConfig(data) {
  return request({
    url: URL.price.saveSurchargeFCLConfig,
    method: 'post',
    data
  })
}
